<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="se-panel-title">消息中心</div>
      </div>
      <div class="panel-body">
        <el-tabs v-model="activeName" type="border-card">
          <el-tab-pane label="全部消息" name="first">
            <el-table :data="allList" highlight-current-row tooltip-effect="light" :row-class-name="tableRowClassName" v-loading="listLoading" style="width: 100%;">
              <el-table-column prop="title" label="标题" min-width="300" align="left">
                <template slot-scope="scope">
                  <span class="msg-state"></span>
                  <span class="z-curPonit a-underline-link" :class="{'msg-title':scope.row.msg_read === '0','z-color-muted':scope.row.msg_read === '1'}" @click="Chakan(scope.row.id)">{{scope.row.title}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="pub_time" label="发送时间" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="z-color-muted">{{scope.row.pub_time}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="caozuo" label="操作" align="center">
                <template slot-scope="scope">
                  <span class="z-curPonit z-color-a a-underline-link" @click="Chakan(scope.row.id)">查看</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChangeAll" :page-size="10" :total="all.total" class="pull-left">
            </el-pagination>
            <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChangeAll" :page-size="all.count" :total="all.total">
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="未读消息" name="second">
            <div class="z-margin-bottom-10-precent">
              <el-button v-show="multipleSelection.length == 0 " plain disabled>标记已读</el-button>
              <el-button v-show="multipleSelection.length > 0" type="primary" @click="Sign" style="margin-left: 0">标记已读</el-button>
              <el-button plain @click="SignAll">全部已读</el-button>
            </div>
            <el-table :data="unreadList" highlight-current-row tooltip-effect="light" :row-class-name="tableRowClassName" @selection-change="selsChange" v-loading="listLoading" style="width: 100%;">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column prop="title" label="标题" min-width="300" align="left">
                <template slot-scope="scope">
                  <span class="msg-state"></span>
                  <span class="z-curPonit msg-title a-underline-link" @click="Chakan(scope.row.id)">{{scope.row.title}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="pub_time" label="发送时间" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="z-color-muted">{{scope.row.pub_time}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="caozuo" label="操作" align="center">
                <template slot-scope="scope">
                  <span class="z-curPonit z-color-a a-underline-link" @click="Chakan(scope.row.id)">查看</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChangeUn" :page-size="10" :total="unread.total" class="pull-left">
            </el-pagination>
            <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChangeUn" :page-size="unread.count" :total="unread.total">
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="已读消息" name="third">
            <el-table :data="readList" highlight-current-row tooltip-effect="light" :row-class-name="tableRowClassName" v-loading="listLoading" style="width: 100%;">
              <el-table-column prop="title" label="标题" min-width="300" align="left">
                <template slot-scope="scope">
                  <span class="msg-state"></span>
                  <span class="z-curPonit z-color-muted a-underline-link" @click="Chakan(scope.row.id)">{{scope.row.title}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="pub_time" label="发送时间" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="z-color-muted">{{scope.row.pub_time}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="caozuo" label="操作" align="center">
                <template slot-scope="scope">
                  <span class="z-curPonit z-color-a a-underline-link" @click="Chakan(scope.row.id)">查看</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChangeRead" :page-size="10" :total="read.total" class="pull-left">
            </el-pagination>
            <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChangeRead" :page-size="read.count" :total="read.total">
            </el-pagination>
          </el-tab-pane>
        </el-tabs>
      </div>
      <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
      <xdialog-error  @ErrorClose="ErrorClose" :dialogError="dialogError" :errorMsg="errorMsg"></xdialog-error>
      <el-dialog
        title="提示信息"
        :visible.sync="dialogSuccess"
        top="20%"
        width="420px"
        :lock-scroll=false
        :close-on-click-modal=false
        :close-on-press-escape=false
        custom-class="dialog"
        @close="dialogSuccessClose">
        <img style="margin-left: 30px;vertical-align: middle" src="../../assets/imgs/uc_success.png" alt="">
        <span class="z-font-size-14 z-margin-left-5-precent">{{dialogSuccessMsg}}</span>
        <span slot="footer" class="dialog-footer">
          </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import userService from 'business/userService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import XdialogError from 'components/commons/XdialogError.vue'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        dialogLoading:false,
        dialogError:false,
        dialogSuccess:false,
        errorMsg:'',
        dialogSuccessMsg:'',
        listLoading:false,
        activeName:'first',
        allList:[],
        multipleSelection:[],
        unreadList:[],
        readList:[],
        all:{
          count:10,
          total:0,
          page:1,
        },
        unread:{
          count:10,
          total:0,
          page:1,
        },
        read:{
          count:10,
          total:0,
          page:1,
        }
      }
    },
    components:{
      XdialogLoading,
      XdialogError
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.MessageAllList()
    },
    watch:{
      activeName(val){
        if(val === 'first'){
          this.MessageAllList()
        }
        if(val === 'second'){
          this.MessageUnReadList()
        }
        if(val === 'third'){
          this.MessageReadList()
        }
      },
    },
    methods:{
      ...mapActions(['MSG']),
      tableRowClassName({row, rowIndex}) {
        if (row.msg_read === '1') {
          return 'msg-read-row msg-row';
        }
        return 'msg-row';
      },
      async MessageAllList() {
        this.listLoading = true
        let data = 'cmd=user_msg_list' +
          '&count='+ this.all.count +
          '&page='+ this.all.page
        let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
        if(vueData.response == 200 ) {
          this.all.total = vueData.msg.allcount
          this.allList = vueData.msg.content
          this.listLoading = false
        }else{
          this.dialogLoading = false
          this.dialogError = true
          this.errorMsg = vueData.msg
        }
      },
      handleCurrentChangeAll(val) {
        this.all.page = val;
        this.MessageAllList()
      },
      handleSizeChangeAll(val) {
        this.all.count = val
        this.MessageAllList()
      },
      selsChange: function (sels) {
        this.multipleSelection = sels;
      },
      async Sign() {
        let id = this.multipleSelection.map(item => {
          return item.id
        })
        let data = 'cmd=user_msg_show' +
          '&read_type=selected' +
          '&id=' + id.join(',')
        let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          this.dialogSuccessMsg = vueData.msg
          this.dialogSuccess = true
          setTimeout(() => {
            this.dialogSuccess = false
          },2000)
        }else{
          this.dialogLoading = false
          this.dialogError = true
          this.errorMsg = vueData.msg
        }
      },
      async SignAll() {
        let data = 'cmd=user_msg_show' +
          '&read_type=all'
        let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          this.dialogSuccessMsg = vueData.msg
          this.dialogSuccess = true
          setTimeout(() => {
            this.dialogSuccess = false
          },2000)
        }else{
          this.dialogLoading = false
          this.dialogError = true
          this.errorMsg = vueData.msg
        }
      },
      async MessageUnReadList() {
        this.listLoading = true
        let data = 'cmd=user_msg_list' +
          '&count='+ this.unread.count +
          '&page='+ this.unread.page +
          '&msg_type=0'
        let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
        if(vueData.response == 200 ) {
          this.unread.total = vueData.msg.allcount
          this.unreadList = vueData.msg.content
          this.listLoading = false
        }else{
          this.dialogLoading = false
          this.dialogError = true
          this.errorMsg = vueData.msg
        }
      },
      handleCurrentChangeUn(val) {
        this.unread.page = val;
        this.MessageUnReadList()
      },
      handleSizeChangeUn(val) {
        this.unread.count = val
        this.MessageUnReadList()
      },
      async MessageReadList() {
        this.listLoading = true
        let data = 'cmd=user_msg_list' +
          '&count='+ this.read.count +
          '&page='+ this.read.page +
          '&msg_type=1'
        let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
        if(vueData.response == 200 ) {
          this.read.total = vueData.msg.allcount
          this.readList = vueData.msg.content
          this.listLoading = false
        }else{
          this.dialogLoading = false
          this.dialogError = true
          this.errorMsg = vueData.msg
        }
      },
      handleCurrentChangeRead(val) {
        this.read.page = val;
        this.MessageReadList()
      },
      handleSizeChangeRead(val) {
        this.read.count = val
        this.MessageReadList()
      },
      Chakan(id) {
        this.$router.push('/message/content/'+ id)
      },
      async dialogSuccessClose() {
        let data = 'cmd=user_msg_list' +
          '&msg_type=0'
        let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
        if(vueData.response == 200 ) {
          this.unread.total = vueData.msg.allcount
          this.unreadList = vueData.msg.content
          this.MSG({
            num:vueData.msg.allcount,
            list:vueData.msg.content
          })
        }else{
          this.dialogLoading = false
          this.dialogError = true
          this.errorMsg = vueData.msg
        }
      },
      ErrorClose(data){
        this.dialogError = data
      },
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
    margin-left: 80px;
  }
  .msg-title {
    color: #4d4d4d;
  }
  .msg-state {
    display: inline-block;
    width: 4px;
    height: 4px;
    margin-right: 7px;
    background: url(../../assets/imgs/icon_msg_state.png) no-repeat center;
    vertical-align: 2.5px;
  }
  .msg-read-row .msg-state {
    background: none;
  }
</style>




// WEBPACK FOOTER //
// src/pages/fuwu/message.vue